(function () {
  'use strict';

  const { scrollTransitions } = window.Universe;

  class ScrollAnimator {
    constructor() {
      this._cvObserver = null;
      this._cvPending = new Map(); // .shopify-section → [{ element, options }]
      this.init();
    }

    // Returns true for sections 3+ — the ones that have content-visibility: auto
    // applied by [data-page-rendering] .l-main .shopify-section + .shopify-section ~ .shopify-section
    _isCVSection(section) {
      let count = 0;
      let prev = section.previousElementSibling;
      while (prev) {
        if (prev.classList.contains('shopify-section') && ++count >= 2) return true;
        prev = prev.previousElementSibling;
      }
      return false;
    }

    _getCVObserver() {
      if (!this._cvObserver) {
        this._cvObserver = new IntersectionObserver((entries) => {
          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (!entry.isIntersecting) continue;
            this._cvObserver.unobserve(entry.target);
            const pending = this._cvPending.get(entry.target);
            if (!pending) continue;
            this._cvPending.delete(entry.target);
            for (let j = 0; j < pending.length; j++) {
              const { element, options } = pending[j];
              if (!element.classList.contains('is-visible')) {
                scrollTransitions.observe(element, options);
              }
            }
          }
        }, { rootMargin: '200px' });
      }
      return this._cvObserver;
    }

    // Routes an element either to the section-boundary pre-observer (when inside a
    // content-visibility: auto section) or directly to scrollTransitions.
    _observeElement(element, options) {
      if (!Shopify.designMode && document.body.hasAttribute('data-page-rendering')) {
        const section = element.closest('.shopify-section');
        if (section && this._isCVSection(section)) {
          const observer = this._getCVObserver();
          if (!this._cvPending.has(section)) {
            this._cvPending.set(section, []);
            observer.observe(section);
          }
          this._cvPending.get(section).push({ element, options });
          return;
        }
      }
      scrollTransitions.observe(element, options);
    }

    observe() {
      if (!this.DOM || !this.DOM.scrollElements) return;

      const mainProduct = document.getElementById('u-main-product');

      for (let i = 0; i < this.DOM.scrollElements.length; i++) {
        const element = this.DOM.scrollElements[i];

        if (element.classList.contains('is-visible')) continue;

        if (mainProduct && mainProduct.contains(element)) {
          this._observeElement(element, { rootMargin: '0px' });
        } else {
          this._observeElement(element);
        }
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      const remaining = [];
      if (this.DOM && this.DOM.scrollElements) {
        for (let i = 0; i < this.DOM.scrollElements.length; i++) {
          const el = this.DOM.scrollElements[i];
          if (!document.contains(el)) {
            scrollTransitions.unobserve(el);
          } else {
            remaining.push(el);
          }
        }
      }

      const newElements = sectionEl.querySelectorAll('[data-scroll]');

      for (let i = 0; i < newElements.length; i++) {
        remaining.push(newElements[i]);
      }

      if (remaining.length) {
        this.DOM = { scrollElements: remaining };

        for (let i = 0; i < newElements.length; i++) {
          scrollTransitions.observe(newElements[i]);
        }
      } else {
        this.DOM = undefined;
      }
    }

    destroySection(sectionEl) {
      if (this.DOM && this.DOM.scrollElements) {
        const remaining = [];
        for (let i = 0; i < this.DOM.scrollElements.length; i++) {
          const el = this.DOM.scrollElements[i];
          if (!document.contains(el)) {
            scrollTransitions.unobserve(el);
          } else {
            remaining.push(el);
          }
        }
        this.DOM = remaining.length ? { scrollElements: remaining } : undefined;
      }
    }

    destroy() {
      if (this.DOM && this.DOM.scrollElements) {
        for (let i = 0; i < this.DOM.scrollElements.length; i++) {
          scrollTransitions.unobserve(this.DOM.scrollElements[i]);
        }
      }
      if (this._cvObserver) {
        this._cvObserver.disconnect();
        this._cvObserver = null;
      }
      this._cvPending = new Map();
      this.DOM = undefined;
    }

    init(container = document) {
      const scrollElements = container.querySelectorAll('[data-scroll]');

      if (scrollElements.length) {
        this.DOM = { scrollElements: scrollElements };
        this.observe();
      }
    }
  }

  window.Universe.ScrollAnimator = ScrollAnimator;
})();
